// export action types
import { ADD_LABELS } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { addLabels } from 'actions/addLabels';
 *
 * // dispatch action
 * store.dispatch( addLabels( payload ) );
 */
export const addLabels = ( payload ) => {
    return {
        type: ADD_LABELS,
        payload: payload
    };
};
